import React, { useRef, useState } from 'react';
import style from './Password.module.less';
import { classesAdd } from 'rootReact/helpers';
import PropTypes from 'prop-types';
import { placeholderPosition } from 'rootReact/UI/helpers';

function Password({
    placeholder = 'Password',
    size = 'lg',
    hint,
    disabled,
    error,
    testId,
    id,
    value,
    handleChange,
    handleBlur,
    handleFocus
}) {
    const [focusStatus, setFocusStatus] = useState(false);
    const [placeStyle, setPlaceStyle] = useState(value ? `${style.placeholderEnd}` : `${style.placeholderStart}`);
    const [isPasswordShow, setIsPasswordShow] = useState(false);
    const inputRef = useRef(null);
    const placeholderRef = useRef(null);

    const focusOnInput = () => {
        inputRef.current.focus();
    };

    return (
        <div
            data-testid={'password-container'}
            className={classesAdd(
                style.container,
                disabled && style.disabled,
                error && style.error
            )}
        >
            <div
                data-testid={'password'}
                className={classesAdd(
                    style.password,
                    focusStatus && style.focus,
                    style[size],
                )}
                onClick={() => focusOnInput()}
            >
                <span
                    ref={placeholderRef}
                    data-testid={'password-placeholder'}
                    className={classesAdd(placeStyle, style.placeholder, style[size])}
                >
                    {placeholder}
                </span>

                <span className={style.inputWrapper}>
                    <input
                        data-testid={testId || 'password_input'}
                        id={id}
                        ref={inputRef}
                        disabled={disabled}
                        type={isPasswordShow ? 'text' : 'password'}
                        value={value}
                        className={classesAdd(style.input, style[size])}
                        onChange={(e) => {
                            handleChange(e);
                            if (value) {
                                placeholderPosition(true, placeholderRef, setPlaceStyle, style, value);
                            }
                        }}
                        onFocus={() => {
                            placeholderPosition(true, placeholderRef, setPlaceStyle, style, value);
                            setFocusStatus(() => true);
                            if (handleFocus) handleFocus();
                        }}
                        onBlur={() => {
                            placeholderPosition(false, placeholderRef, setPlaceStyle, style, value);
                            setFocusStatus(() => false);
                            if (handleBlur) handleBlur();
                        }}
                    />
                </span>

                <div className={style.icon} data-testid={'password-eye'} onClick={(event) => {
                    event.stopPropagation();
                    setIsPasswordShow((state) => !state);
                }}>
                    <svg className={style.svg}>
                        <use xlinkHref={`/image/icoSprite.svg#${isPasswordShow ? 'password-open-eye' : 'password-close-eye'}`}></use>
                    </svg>
                </div>
            </div>

            {hint && <div
                data-testid={'password-text-under-field'}
                className={classesAdd(
                    style.textUnderField,
                )}
            >
                {hint}
            </div>}
        </div>
    );
}

Password.propTypes = {
    placeholder: PropTypes.string,
    hint: PropTypes.string,
    value: PropTypes.string,
    size: PropTypes.oneOf(['lg', 'md']),
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    id: PropTypes.string,
};

export default Password;
